import React, { createContext, PropsWithChildren, useMemo, useState } from 'react';

type AsyncContextType = {
    // error: boolean;
    loading: boolean;
    registerLoading: (key: string) => void;
    unregisterLoading: (key: string) => void;
    setLoading: (key: string, state: boolean) => void;
};

export const AsyncContext = createContext<AsyncContextType>({} as unknown as AsyncContextType);
// export const AsyncContext = createContext<AsyncContextType>(null!);

export const AsyncContextProvider = ({ children }: PropsWithChildren<{}>) => {
    const [loadingRequests, setLoadingRequests] = useState<Record<string, boolean>>({});

    const loading = useMemo(() => !!Object.values(loadingRequests).find((cur) => cur), [loadingRequests]);

    const registerLoading = (key: string) => {
        setLoadingRequests((cur) => ({ ...cur, [key]: false }));
    };

    const unregisterLoading = (key: string) => {
        setLoadingRequests((prevState) => {
            const newState = { ...prevState };
            delete newState[key];
            return newState;
        });
    };

    const setLoading = (key: string, state: boolean) => {
        setLoadingRequests((cur) => ({ ...cur, [key]: state }));
    };

    return (
        <AsyncContext.Provider
            value={{
                loading,
                registerLoading,
                setLoading,
                unregisterLoading,
            }}
        >
            {children}
        </AsyncContext.Provider>
    );
};
